module.exports = __webpack_public_path__ + "img/linkToNewPage.e5730828.svg";